var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"mb-3"},[_vm._v(_vm._s(_vm.data.title))]),_c('apex-chart',{attrs:{"type":"pie","options":_vm.chartOptions,"series":_vm.series,"height":250},on:{"dataPointSelection":_vm.dataPointSelectionHandler}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }